import { DuplicateFieldsPresenter, FieldPresenter } from './reportm.report.fields.js';
import ReportDetailM from '../model/reportm.model.reportdetail.js';
import ReportDetailV from '../view/reportm.view.reportdetail.js';

var ReportDetailP = function(core, $container) {

    var _reportM = new ReportDetailM(core),
        _reportName,
        _entities,
        _duplicableFieldParametersPs = [],
        _fieldParametersPs = [],
        _loadingKey = core.getLoadingKey();

    // TODO huma - porque � que � necess�rio fazer o ||. N�o basta traduzir ?

    var _generatingReportMsg = core.translateString("reportm", "msg.generate") ||
                               "Generating the report...",

        _errorMsg = core.translateString("reportm", "msg.error") ||
                    "There was an error generating the report, please try again later",

        _reportGeneratedMsg = core.translateString("reportm", "msg.success") ||
                              "The report has been generated successfully";


    var _reportV = new ReportDetailV(core, $container, {
        generateReport: function() {
            _generateReport();
        },
        goBack: core.navigateBack
    });

    var _generateReport = function() {
        _reportV.disableButtons();

        if (_reportM.hasParameters()) {
            if (_validate()) {

                _reportV.showGeneratingReportMsg(
                    _generatingReportMsg,
                    _reportM.hasParameters());

                var parameters = [];

                _fieldParametersPs.forEach(function(el) {
                    parameters.push(el.getModel());
                });

                _duplicableFieldParametersPs.forEach(function(el) {
                    parameters.push(el.getModel());
                });

                _reportM.
                    setReportParameters(parameters).
                    generateReport(_entities);

                core.showLoading(_loadingKey, "generate report");
            } else {
                _reportV.enableButtons();
            }
        } else {
            _reportV.showGeneratingReportMsg(_generatingReportMsg, _reportM.hasParameters());

            core.showLoading(_loadingKey, "generate report");

            _reportM.generateReport();
        }
    };

    var _validate = function() {
        var allOk = true;

        _fieldParametersPs.forEach(function(fieldP) {
            allOk = fieldP.validate() && allOk;
        });

        _duplicableFieldParametersPs.forEach(function(dupP) {
            allOk = dupP.validate() && allOk;
        });

        return allOk;
    };

    var _handleReportLoadingFinished = function() {
        var reportParams;

        _reportV.showReport(_reportM);

        if (_reportM.hasParameters()) {

            reportParams = _reportM.getReportParameters();

            reportParams.map(function(parameter) {

                parameter.id = String(core.locallyUniqueId());

                if (parameter.duplicable) {
                    _duplicableFieldParametersPs.push(new DuplicateFieldsPresenter(
                        core,
                        _reportV,
                        parameter
                    ));

                } else {
                    var newFieldP = new FieldPresenter(
                        core,
                        parameter
                    );
                    _fieldParametersPs.push(newFieldP);
                    _reportV.addField(newFieldP);
                }
            });

        } else {
            core.showLoading(_loadingKey, "generating report");

            _reportV.showGeneratingReportMsg(_generatingReportMsg, _reportM.hasParameters());

            _reportM.generateReport();
        }

        core.hideLoading(_loadingKey, "loading report");
    };

    var _handleReportGenerationFinished = function() {

        _reportV.showReportGenerationSuccessMsg(
            _reportGeneratedMsg,
            _reportM.hasParameters());

        _reportV.enableButtons();

        core.hideLoading(_loadingKey, "generate report");
    };

    var _handleReportGenerationError = function() {
        _reportV.showReportGenerationErrorMsg(_errorMsg, _reportM.hasParameters());

        _reportV.enableButtons();

        core.hideLoading(_loadingKey, "generate report");
    };

    var _showReportNotFound = function() {
        _reportV.showReportNotAvailable(_reportName);

        core.hideLoading(_loadingKey, "loading report");
    };

    var _subscribeEvents = function() {
        core.subscribe("reportm:report-generated", _handleReportGenerationFinished);
        core.subscribe("reportm:report-generation-error", _handleReportGenerationError);
        core.subscribe("reportm:report-loaded", _handleReportLoadingFinished);
        core.subscribe("reportm:report-not-found", _showReportNotFound);
    };

    var _unsubscribeEvents = function() {
        core.unsubscribe("reportm:report-generated", _handleReportGenerationFinished);
        core.unsubscribe("reportm:report-generation-error", _handleReportGenerationError);
        core.unsubscribe("reportm:report-loaded", _handleReportLoadingFinished);
        core.unsubscribe("reportm:report-not-found", _showReportNotFound);
    };

    return{
        init: function(reportName, entities) {
            _reportName = reportName;

            _entities = entities;

            _subscribeEvents();

            core.showLoading(_loadingKey, "loading report");

            _reportM.loadReport(reportName);
        },
        pause: function() {
            _unsubscribeEvents();
        },
        resume: function() {
            _subscribeEvents();
        },
        destroy: function() {
            _unsubscribeEvents();
        }
    };
};

export default ReportDetailP;
